module.exports = __webpack_public_path__ + "img/inst-6.cc3daf9d.png";